import React from "react";
import Icons from "customComponents/icons";
import "./style.scss";

const Banner = props => {
    const { _closeBanner, text = "", iconType } = props;
    return (
        <div className="kyc_popup flex-vertical-center">
            <Icons type={iconType} className="margin-lr-50 alert-orange-color" />
            <div>{text}</div>
            <Icons type="cross" size="small" className="banner-cross" onClick={_closeBanner} />
        </div>
    );
};

export default Banner;
